export const useNoSubmit = () => {
  return () => {
    console.error('Method not implemented!');
  };
};
